import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function parseDate(dateStr) {
  if (!dateStr) return null;
  if (dateStr instanceof Date) return dateStr;
  
  // Convert "YYYY-MM-DD HH:mm:ss+00" to standard ISO "YYYY-MM-DDTHH:mm:ssZ"
  let cleanStr = String(dateStr).trim().replace(" ", "T");
  
  // Standardize timezone offset format
  if (cleanStr.endsWith("+00")) {
    cleanStr = cleanStr.substring(0, cleanStr.length - 3) + "Z";
  } else if (cleanStr.endsWith("+00:00")) {
    cleanStr = cleanStr.substring(0, cleanStr.length - 6) + "Z";
  } else if (cleanStr.match(/\+\d{2}$/)) {
    cleanStr += ":00";
  } else if (cleanStr.match(/-\d{2}$/)) {
    cleanStr += ":00";
  } else if (!cleanStr.endsWith("Z") && !cleanStr.includes("+") && !cleanStr.includes("-")) {
    // If no timezone offset is present, assume UTC (match times are always UTC)
    cleanStr += "Z";
  }
  
  const parsed = new Date(cleanStr);
  return isNaN(parsed.getTime()) ? new Date(dateStr) : parsed;
}

